import React, { Fragment, lazy } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MobileNav } from '../components/MobileNav';
export function Home() {
  return <>
      <Helmet data-id="element-1841">
        <title data-id="element-1842">Lazy Monk Labs | Truth, engineered.</title>
        <meta name="description" content="We build structured mirrors that reveal the architecture underneath your decisions, reactions, and recurring friction." data-id="element-1843" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] selection:bg-white selection:text-black font-sans" data-id="element-1844">
        <MobileNav data-id="element-1845" />

        <main data-id="element-1846">
          {/* 1. HERO */}
          <section className="min-h-[85vh] flex flex-col justify-center items-center px-6 py-20 text-center" data-id="element-1847">
            <div className="max-w-4xl mx-auto space-y-8" data-id="element-1848">
              <h1 className="text-5xl md:text-7xl lg:text-8xl leading-[1.1] tracking-tight text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1849">
                Truth, engineered.
              </h1>
              <p className="text-xl md:text-2xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-1850">
                A Decode names the pattern beneath your decisions.
              </p>
              <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-1851">
                <a href="https://app.lazymonklabs.com" className="px-10 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm uppercase tracking-widest font-medium hover:bg-gray-200 transition-colors rounded-sm" data-id="element-1852">
                  Start a Decode
                </a>
                <Link to="/learnmore/founder" className="text-gray-500 hover:text-gray-300 text-sm transition-colors py-4" data-id="element-1853">
                  Learn how it works →
                </Link>
              </div>
            </div>
          </section>

          {/* 2. THE PROBLEM */}
          <section className="py-24 md:py-32 px-6 border-t border-[#2B2B2B]" data-id="element-1854">
            <div className="max-w-3xl mx-auto space-y-10" data-id="element-1855">
              <h2 className="text-3xl md:text-4xl text-[#F5F5F5] leading-tight" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1856">
                Most tools optimise behaviour. Few explain structure.
              </h2>
              <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-1857">
                <p className="text-gray-400" data-id="element-1858">
                  You change habits. You try frameworks. The pattern underneath
                  stays the same.
                </p>
                <p className="text-gray-400" data-id="element-1859">
                  Without structural clarity, change becomes repetition.
                </p>
                <p className="text-[#F5F5F5]" data-id="element-1860">
                  Lazy Monk Labs builds mirrors for that structure.
                </p>
              </div>
            </div>
          </section>

          {/* 3. DECODE — Single product focus */}
          <section className="py-24 md:py-32 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1861">
            <div className="max-w-3xl mx-auto space-y-10" data-id="element-1862">
              <h2 className="text-3xl md:text-4xl text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1863">
                Decode
              </h2>
              <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-1864">
                <p className="text-gray-400" data-id="element-1865">
                  A structured reflection that names the pattern behind your
                  current friction.
                </p>
                <p className="text-gray-400" data-id="element-1866">
                  Enter your details. Get a structural read.
                </p>
                <p className="text-[#F5F5F5]" data-id="element-1867">
                  Not advice. Not personality labels. A mirror of the pattern
                  already running.
                </p>
              </div>
              <div className="pt-4" data-id="element-1868">
                <a href="https://app.lazymonklabs.com" className="px-10 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm uppercase tracking-widest font-medium hover:bg-gray-200 transition-colors rounded-sm inline-block" data-id="element-1869">
                  Start a Decode
                </a>
              </div>
            </div>
          </section>

          {/* 4. EXAMPLE DECODE FRAGMENT — Micro output preview */}
          <section className="py-20 md:py-28 px-6 border-t border-[#2B2B2B]" data-id="element-1870">
            <div className="max-w-2xl mx-auto" data-id="element-1871">
              <p className="text-xs font-mono text-gray-600 uppercase tracking-widest mb-10" data-id="element-1872">
                Example Decode Fragment
              </p>

              <div className="space-y-8" data-id="element-1873">
                <div className="space-y-2" data-id="element-1874">
                  <p className="text-xs font-mono text-gray-500 uppercase tracking-wider" data-id="element-1875">
                    Pattern
                  </p>
                  <p className="text-lg md:text-xl text-[#F5F5F5] leading-relaxed" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-1876">
                    You don't hesitate because you're unsure. You hesitate
                    because you don't trust unfinished thinking.
                  </p>
                </div>

                <div className="space-y-2" data-id="element-1877">
                  <p className="text-xs font-mono text-gray-500 uppercase tracking-wider" data-id="element-1878">
                    Tension
                  </p>
                  <p className="text-lg md:text-xl text-[#F5F5F5] leading-relaxed" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-1879">
                    You build structure to feel safe. Then resent the structure
                    for limiting you.
                  </p>
                </div>

                <div className="space-y-2" data-id="element-1880">
                  <p className="text-xs font-mono text-gray-500 uppercase tracking-wider" data-id="element-1881">
                    Cost
                  </p>
                  <p className="text-lg md:text-xl text-[#F5F5F5] leading-relaxed" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-1882">
                    Left unchecked: high competence, low aliveness.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 5. THE PHILOSOPHY */}
          <section className="py-24 md:py-32 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1883">
            <div className="max-w-3xl mx-auto space-y-10" data-id="element-1884">
              <h2 className="text-3xl md:text-4xl text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1885">
                Humans are systems.
              </h2>
              <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-1886">
                <p className="text-gray-400" data-id="element-1887">
                  Every person operates through internal architecture — patterns
                  of perception, adaptation, reaction, and integration.
                </p>
                <p className="text-gray-400" data-id="element-1888">
                  When that architecture is visible, urgency softens. Decisions
                  become cleaner.
                </p>
                <p className="text-[#F5F5F5]" data-id="element-1889">
                  We use structured modeling to translate complexity into
                  clarity — without reducing dignity.
                </p>
              </div>
            </div>
          </section>

          {/* 6. WHO THIS IS FOR */}
          <section className="py-24 md:py-32 px-6 border-t border-[#2B2B2B]" data-id="element-1890">
            <div className="max-w-3xl mx-auto space-y-10" data-id="element-1891">
              <h2 className="text-3xl md:text-4xl text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1892">
                Built for the reflective.
              </h2>
              <div className="space-y-4 text-lg md:text-xl text-gray-400 font-light" data-id="element-1893">
                <p data-id="element-1894">People who replay decisions after they make them.</p>
                <p data-id="element-1895">People who feel responsible even when no one asked.</p>
                <p data-id="element-1896">People who sense the friction before they can name it.</p>
                <p data-id="element-1897">
                  People who prefer seeing the pattern over being told what to
                  do.
                </p>
              </div>
            </div>
          </section>

          {/* 7. QUIET SOCIAL PROOF — With minimal attribution */}
          <section className="py-24 md:py-32 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1898">
            <div className="max-w-3xl mx-auto space-y-16" data-id="element-1899">
              <div className="space-y-4" data-id="element-1900">
                <blockquote className="text-xl md:text-2xl text-gray-400 font-light italic leading-relaxed" data-id="element-1901">
                  "Everything resonated. What struck me most was that what I'm
                  already working toward — intuitively and logically — is
                  exactly what the report highlighted. It felt like confirmation
                  that I'm moving in the right direction."
                </blockquote>
              </div>
              <div className="space-y-4" data-id="element-1902">
                <blockquote className="text-xl md:text-2xl text-gray-400 font-light italic leading-relaxed" data-id="element-1903">
                  "It completely resonated with who I am. The model acts like a
                  very clean mirror. I was surprised by the clarity and
                  precision."
                </blockquote>
              </div>
              <div className="space-y-4" data-id="element-1904">
                <blockquote className="text-xl md:text-2xl text-gray-400 font-light italic leading-relaxed" data-id="element-1905">
                  "It resonated deeply. It was clear and direct, without
                  overcomplicating things. It helped me understand myself in a
                  way that felt grounded."
                </blockquote>
              </div>
            </div>
          </section>

          {/* 8. FINAL CTA — Single, clean */}
          <section className="py-24 md:py-32 px-6 border-t border-[#2B2B2B]" data-id="element-1906">
            <div className="max-w-3xl mx-auto space-y-8" data-id="element-1907">
              <p className="text-lg md:text-xl text-gray-400 font-light leading-relaxed" data-id="element-1908">
                If something in your life keeps repeating and you can't name it
                — this is where you start.
              </p>
              <div className="pt-4" data-id="element-1909">
                <a href="https://app.lazymonklabs.com" className="px-10 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm uppercase tracking-widest font-medium hover:bg-gray-200 transition-colors rounded-sm inline-block" data-id="element-1910">
                  Start a Decode
                </a>
              </div>
              <div className="pt-6" data-id="element-1911">
                <Link to="/learnmore/founder" className="text-gray-600 hover:text-gray-400 transition-colors text-sm" data-id="element-1912">
                  Learn how it works →
                </Link>
              </div>
            </div>
          </section>

          {/* 9. FOOTER */}
          <footer className="py-16 px-6 bg-[#0A0A0A] border-t border-[#2B2B2B]" data-id="element-1913">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-1914">
              <div className="flex flex-col gap-4" data-id="element-1915">
                <a href="https://app.lazymonklabs.com" className="text-gray-500 hover:text-[#F5F5F5] transition-colors text-sm" data-id="element-1916">
                  Start a Decode
                </a>
                <Link to="/decoder" className="text-gray-500 hover:text-[#F5F5F5] transition-colors text-sm" data-id="element-1917">
                  Decoder
                </Link>
                <Link to="/careers" className="text-gray-500 hover:text-[#F5F5F5] transition-colors text-sm" data-id="element-1918">
                  Careers
                </Link>
                <a href="mailto:anish@lazymonklabs.com" className="text-gray-500 hover:text-[#F5F5F5] transition-colors text-sm" data-id="element-1919">
                  Contact
                </a>
              </div>

              <div className="text-gray-600 text-xs font-mono mt-8 md:mt-0" data-id="element-1920">
                © {new Date().getFullYear()} Lazy Monk Labs
              </div>
            </div>
          </footer>
        </main>
      </div>
    </>;
}